/* One queue for page + drawer. Checkout waits for persistence. */
(() => {
  if (customElements.get('fulfillment-preferences')) return;
  const shipping = ['配送希望日', '配送希望時間帯'];
  // 店舗受け取りは 2026-09-18 に終了。古いカートに残っている属性は空にして消す。
  const retired = ['お受け取り方法の希望', '店舗受け取り希望日', '店舗受け取り目安時間', '店舗受け取り時のお渡し方法'];
  let queue = Promise.resolve(), pending = 0, failed = false, latest = null;
  const roots = () => [...document.querySelectorAll('fulfillment-preferences')];
  function status(text, retry = false) {
    roots().forEach(root => {
      root.querySelector('[role="status"]').textContent = text;
      root.querySelector('[data-save-retry]').hidden = !retry;
      root.setAttribute('aria-busy', pending > 0 ? 'true' : 'false');
    });
  }
  function save(attributes) {
    latest = attributes;
    roots().forEach(root => root.apply(attributes));
    pending++;
    status('希望内容を保存しています…');
    queue = queue.then(async () => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      let response;
      try {
        response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST', headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({attributes}), signal: controller.signal,
        });
      } finally { clearTimeout(timeout); }
      if (!response.ok) throw new Error('Save failed');
      const cart = await response.json();
      if (Object.keys(attributes).some(key => (cart.attributes[key] || '') !== attributes[key])) {
        throw new Error('Preferences did not persist');
      }
      failed = false;
    }).catch(() => { failed = true; }).finally(() => {
      pending--;
      if (!pending) status(failed ? '保存できませんでした。通信状態をご確認のうえ、もう一度保存してください。' : '希望内容を保存しました。', failed);
    });
    return queue;
  }
  function collect(root) {
    const attributes = {};
    shipping.forEach(key => {
      const input = [...root.querySelectorAll('[data-attr]')].find(el => el.dataset.attr === key);
      attributes[key] = input ? input.value : '';
    });
    retired.forEach(key => { attributes[key] = ''; });
    return attributes;
  }
  class FulfillmentPreferences extends HTMLElement {
    connectedCallback() {
      if (latest) this.apply(latest);
      this.onChange = event => {
        if (!event.target.dataset.attr) return;
        save(collect(this));
      };
      this.addEventListener('change', this.onChange);
      this.querySelector('[data-save-retry]').onclick = () => { if (latest) save(latest); };
      if (failed) status('保存できていない希望内容があります。もう一度保存してください。', true);
      // 日付指定不可の商品が後から入ったとき、前に選んだ日付がカートに残る。
      // 画面から直せないまま購入手続きで弾かれるので、ここで黙って消す。
      if (this.querySelector('[data-clear-delivery-date]') && !pending) save(collect(this));
    }
    disconnectedCallback() { this.removeEventListener('change', this.onChange); }
    apply(attributes) {
      this.querySelectorAll('[data-attr]').forEach(input => {
        const value = attributes[input.dataset.attr] || '';
        if (input.type === 'radio') input.checked = input.value === value;
        else input.value = value;
      });
    }
  }
  customElements.define('fulfillment-preferences', FulfillmentPreferences);
  // requestSubmit re-enters the handler only after the queue is drained successfully.
  document.addEventListener('submit', event => {
    if (event.submitter?.name !== 'checkout') return;
    const form = event.target, submitter = event.submitter;
    if (!pending && !failed) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (failed && !pending) {
      status('希望内容の保存に失敗しています。もう一度保存してからお進みください。', true);
      return;
    }
    queue.then(() => {
      if (failed || pending || !form.isConnected) return;
      form.requestSubmit(submitter);
    });
  }, true);
})();
